import { BrandSearch } from '@/src/modules/algolia/BrandSearch'
import { StyledH1 } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { FAQ_PAGE } from '@/src/modules/pg-plus/constants'

type TChangeBrandInWallet = {
    error: any[] | null
    exchangeIsError: boolean
}

const WalletChangeBrandContent = ({
    error,
    exchangeIsError,
}: TChangeBrandInWallet) => {
    const { dispatch, giftState, isUnbrandedToEgift } =
        usePGPlusStepAndModalContext()
    const { denomination } = giftState

    return (
        <>
            <StyledH1 style={{ fontSize: '2.5rem', marginTop: 20 }}>
                Choose a brand
            </StyledH1>
            <p>
                We are partnered with a perfect selection of all your favorite
                national brands in the United States.
            </p>
            <BrandSearch
                denomination={denomination}
                minHeight={'brands-page'}
                dispatch={dispatch}
                isUnbrandedToEgift={isUnbrandedToEgift}
            />
            {error ? (
                <p className={'error'}>{error}</p>
            ) : (
                exchangeIsError && (
                    <p className={'error'}>
                        Unable to change brand. Please try again. If issues
                        persist, see our list of{' '}
                        <a href={FAQ_PAGE}>frequently asked questions</a>.
                    </p>
                )
            )}
        </>
    )
}

export default WalletChangeBrandContent
